import { render } from "./Serve.vue?vue&type=template&id=ca11a18c&scoped=true"
import script from "./Serve.vue?vue&type=script&lang=js"
export * from "./Serve.vue?vue&type=script&lang=js"

import "./Serve.vue?vue&type=style&index=0&id=ca11a18c&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca11a18c"]])

export default __exports__